// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assetsListBlock__vLfch {
  grid-area: 2/1/3/2;
}

.blockHead__wCYYA {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.blockTitle__r8dpr {
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.blockContainer__ikZXM {
  height: calc(100vh - 267px);
  margin-top: 10px;
  background: var(--tables-primary-row-surface-default);
  border: 1px solid var(--header-stroke);
  overflow-y: auto;
}
.blockContainer__ikZXM::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.blockContainer__ikZXM::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.blockContainer__ikZXM::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.blockContainer__ikZXM::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.assetsTable__wm2Nl {
  width: 100%;
  height: 100%;
}

.assetsTableHead__wPdE1 {
  background: var(--tables-title-surface);
}

.assetsTableTh__PXXVq {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: var(--tables-secondary-row-sub-title-text);
  text-transform: uppercase;
  text-align: left;
  padding: 15px;
  background: var(--tables-title-surface);
  border-bottom: 1px solid var(--header-stroke);
  position: sticky;
  top: 0;
}
.assetsTableTh__PXXVq:first-child {
  padding-left: 15px;
}

.sortIcon__Z7I03 {
  margin-left: 5px;
  cursor: pointer;
  outline: none;
}

.assetsTableBodyRow__BeH6I:hover {
  background: var(--tables-primary-row-surface-hover);
}

.assetsTableTd__SOeEO {
  padding: 15px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 12px;
}
.assetsTableTd__SOeEO:not(:last-child) {
  min-width: 115px;
}

.actionsIconContainer__hJ31o {
  width: 35px;
  cursor: pointer;
}

.skeletonText__YFYtC {
  height: 12px;
}

.activeRow__jgtC8 {
  background: var(--tables-primary-row-surface-hover);
}`, "",{"version":3,"sources":["webpack://./../src/pages/GPSAssetTracking/components/AssetsList/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,kBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,2BAAA;EACA,gBAAA;EACA,qDAAA;EACA,sCAAA;EACA,gBAAA;AAzEF;AAFE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAIJ;AADE;EACE,+BAAA;EACA,kBAAA;AAGJ;AAAE;EACE,8BAAA;EACA,kBAAA;AAEJ;AACE;EACE,gBAAA;EACA,kBAAA;AACJ;;AA6DA;EACE,WAAA;EACA,YAAA;AA1DF;;AA6DA;EACE,uCAAA;AA1DF;;AA6DA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iDAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,uCAAA;EACA,6CAAA;EACA,gBAAA;EACA,MAAA;AA1DF;AA4DE;EACE,kBAAA;AA1DJ;;AA8DA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;AA3DF;;AA+DE;EACE,mDAAA;AA5DJ;;AAgEA;EACE,aAAA;EACA,yDAAA;EACA,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA7DF;AA+DE;EACE,gBAAA;AA7DJ;;AAiEA;EACE,WAAA;EACA,eAAA;AA9DF;;AAiEA;EACE,YAAA;AA9DF;;AAiEA;EACE,mDAAA;AA9DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.assetsListBlock {\n  grid-area: 2 / 1 / 3 / 2;\n}\n\n.blockHead {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.blockTitle {\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n}\n\n.blockContainer {\n  height: calc(100vh - 267px);\n  margin-top: 10px;\n  background: var(--tables-primary-row-surface-default);\n  border: 1px solid var(--header-stroke);\n  overflow-y: auto;\n\n  @include scrollBar;\n}\n\n.assetsTable {\n  width: 100%;\n  height: 100%;\n}\n\n.assetsTableHead {\n  background: var(--tables-title-surface);\n}\n\n.assetsTableTh {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 14px;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-transform: uppercase;\n  text-align: left;\n  padding: 15px;\n  background: var(--tables-title-surface);\n  border-bottom: 1px solid var(--header-stroke);\n  position: sticky;\n  top: 0;\n\n  &:first-child {\n    padding-left: 15px;\n  }\n}\n\n.sortIcon {\n  margin-left: 5px;\n  cursor: pointer;\n  outline: none;\n}\n\n.assetsTableBodyRow {\n  &:hover {\n    background: var(--tables-primary-row-surface-hover);\n  }\n}\n\n.assetsTableTd {\n  padding: 15px;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 12px;\n\n  &:not(:last-child) {\n    min-width: 115px;\n  }\n}\n\n.actionsIconContainer {\n  width: 35px;\n  cursor: pointer;\n}\n\n.skeletonText {\n  height: 12px;\n}\n\n.activeRow {\n  background: var(--tables-primary-row-surface-hover);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"assetsListBlock": `assetsListBlock__vLfch`,
	"blockHead": `blockHead__wCYYA`,
	"blockTitle": `blockTitle__r8dpr`,
	"blockContainer": `blockContainer__ikZXM`,
	"assetsTable": `assetsTable__wm2Nl`,
	"assetsTableHead": `assetsTableHead__wPdE1`,
	"assetsTableTh": `assetsTableTh__PXXVq`,
	"sortIcon": `sortIcon__Z7I03`,
	"assetsTableBodyRow": `assetsTableBodyRow__BeH6I`,
	"assetsTableTd": `assetsTableTd__SOeEO`,
	"actionsIconContainer": `actionsIconContainer__hJ31o`,
	"skeletonText": `skeletonText__YFYtC`,
	"activeRow": `activeRow__jgtC8`
};
module.exports = ___CSS_LOADER_EXPORT___;
